import feathersClient from "../../feathers-client";

const defaultRosterPagination = {
	total:100,
	$skip:0,
	$limit:10,
};
const defaultRosterPaginationFilter = {
	$skip:defaultRosterPagination.$skip,
	$limit: defaultRosterPagination.$limit
};
const defaultRosterStaffPagination = {
	total:100,
	$skip:0,
	$limit:10,
};
const defaultRosterStaffPaginationFilter = {
	$skip:defaultRosterPagination.$skip,
	$limit: defaultRosterPagination.$limit
};


export default {
	namespaced:true,
	state:{
		rosterList:[],
		rosterPagination:defaultRosterPagination,
		rosterPaginationFilter:defaultRosterPaginationFilter,
		staffRosterAvailability:[],
		staffRosterPagination:defaultRosterStaffPagination,
		staffRosterFilter:defaultRosterStaffPaginationFilter,
		staffRosterPersonaFilter:[],
	},
	getters:{
		setRosterPage:(state) => {
			const {$limit, $skip} = state.rosterPagination;
			return $skip / $limit + 1;
		},
		setStaffRosterPage:(state) => {
			const {$limit, $skip} = state.staffRosterPagination;
			return $skip / $limit + 1;
		}
	},
	mutations:{
		SET_ROSTER_LIST:(state,data) => {state.rosterList = data;},
		SET_ROSTER_LIST_PAGINATION:(state,data) => {state.rosterPagination = {...state.rosterPagination,...data}},
		SET_ROSTER_LIST_PAGINATION_FILTER:(state,data) => {state.rosterPaginationFilter = {...state.rosterPaginationFilter, ...data}},
		SET_STAFF_ROSTER_AVAILABILITY:(state,data) => {state.staffRosterAvailability = data},
		SET_STAFF_ROSTER_LIST_PAGINATION:(state,data) => {state.staffRosterPagination = {...state.staffRosterPagination,...data}},
		SET_STAFF_ROSTER_LIST_FILTER:(state,data) => {state.staffRosterFilter = {...state.staffRosterFilter, ...data}},
		SET_STAFF_ROSTER_PERSONA_FILTER:(state,data) => {state.staffRosterPersonaFilter = {...state.staffRosterPersonaFilter, ...data}},
	},
	actions:{
		setTheListPage:({commit,state}, page) =>{
			const $skip = (page - 1) * state.rosterPagination.$limit;
			commit('SET_ROSTER_LIST_PAGINATION', { $skip });
			commit('SET_ROSTER_LIST_PAGINATION_FILTER', { $skip });
		},
		setRosterStaffListPage:({commit,state}, page) =>{
			const $skip = (page - 1) * state.staffRosterPagination.$limit;
			commit('SET_STAFF_ROSTER_LIST_PAGINATION', { $skip });
			commit('SET_STAFF_ROSTER_LIST_FILTER', { $skip });
		},
		setRosterPersonaFilter:({commit,state}, filter) =>{
			commit('SET_STAFF_ROSTER_PERSONA_FILTER', filter);
		},
		getLatestRosterAvailability: async ({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/roster-availability').find({
				query:{
					$role: rootGetters.currentUserRole,
					$latestRequestDetails:true,
					...filter,
				}
			});
			return results.data;
		},
		getAllRosterAvailability: async ({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/roster-availability').find({
				query:{
					$role: rootGetters.currentUserRole,
					$addCompletionCount:true,
					...filter,
				}
			});
			commit('SET_ROSTER_LIST',results.data);
			commit('SET_ROSTER_LIST_PAGINATION', {total :results.total})
			return results.data;
		},
		isUsingMasterTemplates: async({state,commit},id) => {
			const results = await feathersClient.service('/api/v3/care-locations').get(id,{
				query:{
					$select:['isMasterShiftTemplate']
				}
			});
			return results
		},
		createRosterAvailability: async({rootGetters, commit},data) => {
			const results = await feathersClient.service('/api/v3/roster-availability').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
					$createRoster:true,
				}
			});
			return results
		},
		getSatffRosterAvailabilityDaily: async({state,commit,rootGetters},filter) => {
			const results = await feathersClient.service('/api/v3/get-staff-roster-availability-actions').find({
				query:{
					$role: rootGetters.currentUserRole,
					$getStaffDailyView: true,
					...filter
				}
			});
			commit('SET_STAFF_ROSTER_AVAILABILITY',results.data)
			commit('SET_STAFF_ROSTER_LIST_PAGINATION',{total:results.total})
			return results
		},
		getSatffRosterAvailabilityMonth: async({state,commit,rootGetters},filter) => {
			const results = await feathersClient.service('/api/v3/get-staff-roster-availability-actions').find({
				query:{
					$role: rootGetters.currentUserRole,
					$getStaffMonthlyView: true,
					...filter
				}
			});
			// commit('SET_STAFF_ROSTER_AVAILABILITY',results.data)
			// commit('SET_STAFF_ROSTER_LIST_PAGINATION',{total:results.total})
			return results
		},
		getPersona: async({state,commit,rootGetters},filter) => {
			const results = await feathersClient.service('/api/v3/get-staff-roster-availability-actions').find({
				query:{
					$role: rootGetters.currentUserRole,
					$getPersonas: true,
					...filter
				}
			});
			return results
		},
		getStaffMatchScore: async({state,commit,rootGetters},filter) => {
			const results = await feathersClient.service('/api/v3/get-staff-roster-availability-actions').find({
				query:{
					$role: rootGetters.currentUserRole,
					...filter
				}
			});
			return results
		},
		getRosterSetupById: async({state, commit,rootGetters},id) => {
			const results = await feathersClient.service('/api/v3/roster-availability').get(id,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		updateRosterAVailability : async({rootGetters,commit,},data) => {
			const id = data.id
			delete data.id
			const results = await feathersClient.service('/api/v3/roster-availability').patch(id,data,{
				query:{
					$role: rootGetters.currentUserRole,
					$patchRoster:true,
				}
			});
			return results
		},
		deleteRosterSetupAvailability: async ({rootGetters,commit,},id) =>{
			const results = await feathersClient.service('/api/v3/roster-availability').remove(id,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results
		},
		getDefaultFilters: async ({rootGetters,commit,rootState}, filter) =>{
			const results = await feathersClient.service('/api/v3/roster-filter-activities').find({
				query:{
					$role: rootGetters.currentUserRole,
					trustId: rootState?.organizationStore?.currentTrustId,
					$paginate:false,
					...filter
				}
			});
			return results
		}
	}
}
